import { makeStyles } from "@material-ui/core/styles"

const drawerWidth = 205

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    backgroundColor: "transparent !important",
    paddingRight: 24, // keep right padding when drawer closed
  },
  appBar: {
    backgroundColor: "#f1f5f1 !important",
    color: "#000000 !important",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
    color: '#000000 !important'
  },
  appName: {
    fontSize: 30,
    fontWeight: "bold",
    background:
      "-webkit-linear-gradient(135deg, rgba(173,5,131,1) 14%, rgba(5,170,212,1) 100%)",
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent",
      lineHeight: 1,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    color: '#000000',
    paddingTop: 10,
    paddingBottom: 10,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    paddingBottom: theme.spacing(8),
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}))

export default useStyles
